import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonSubmit.module.scss'

const ButtonSubmit = () => {

  return (
    <div className={styles.buttonSubmitContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'settings-button-label'}
            defaultMessage={'Confirm'}
          />
        )}
      />
    </div>
  );
};

export default ButtonSubmit;
